
import React, { useState, useEffect } from 'react';
import { ChevronDown } from "lucide-react";
import { useNavigate } from 'react-router-dom';

const QUOTE_ID = 'A82RUygGsGKW';

const Accordion = ({ title, children, onOpen }) => {
    const [isOpen, setIsOpen] = useState(false);
    const handleToggle = () => {
        const next = !isOpen;
        setIsOpen(next);

        if (next && onOpen) {
            onOpen(title);
        }
    };
    return (
        <div className={`accordion ${isOpen ? "open" : ""}`}>
            <button className="accordion-trigger" onClick={handleToggle}>
                <h3>{title}</h3>
                <ChevronDown className={`accordion-icon ${isOpen ? "rotated" : ""}`} />
            </button>
            {isOpen && <>{children}</>}
        </div>
    );
};

function Quote_A82RUygGsGKW() {
    const navigate = useNavigate();
    const [input, setInput] = useState('');
    const [unlocked, setUnlocked] = useState(false);
    const [error, setError] = useState('');
    const [suppressNotifications, setSuppressNotifications] = useState('');

    const [quoteData, setQuoteData] = useState(null);

    useEffect(() => {
        fetch(`/api/quoteRoute/${QUOTE_ID}`)
            .then(r => r.json())
            .then(setQuoteData);
    }, []);

    const unlock = (suppressNotification = false) => {
        setUnlocked(true);
        setSuppressNotifications(suppressNotification);

        if (suppressNotification) return;

        fetch('/api/quoteRoute/viewed', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ quoteId: QUOTE_ID })
        }).catch(() => { });
    };

    const trackAccordionOpen = (sectionTitle) => {
        if (suppressNotifications) return;
        fetch('/api/quoteRoute/interaction', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                quoteId: QUOTE_ID,
                type: 'accordion_open',
                section: sectionTitle
            })
        }).catch(() => { });
    };

    if (!unlocked) {
        return (
            <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f9fafb' }}>
                <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: '8px', padding: '2rem', width: '100%', maxWidth: '380px', textAlign: 'center' }}>
                    <img src='/transparent-logo-min.png' alt='Logo' style={{ width: '100%', marginBottom: '1rem' }} />
                    <h2 style={{ marginBottom: '0.25rem' }}>Your Quote</h2>
                    <p style={{ color: '#6b7280', marginBottom: '1.5rem', fontSize: '0.9rem' }}>North Florida Home Repair & Maintenance</p>
                    <input
                        type="text"
                        placeholder="Enter your access code"
                        value={input}
                        onChange={e => setInput(e.target.value)}
                        onKeyDown={e => {
                            if (e.key === 'Enter') {
                                const cleaned = input.replace(/\D/g, '') || input.trim();
                                const validCodes = [
                                    quoteData?.clientPhone,
                                    quoteData?.clientPhone2,
                                    quoteData?.customPassword,
                                ].filter(Boolean).map(c => c.replace(/\D/g, '') || c.trim());

                                if (cleaned === '1131') {
                                    unlock(true);
                                } else if (validCodes.includes(cleaned)) {
                                    unlock();
                                } else {
                                    setError('Incorrect. Try again.');
                                }
                            }
                        }}
                        style={{ padding: '0.5rem 0.75rem', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '0.95rem', width: '100%', boxSizing: 'border-box', marginBottom: '0.5rem' }}
                    />
                    {error && <p style={{ color: '#ef4444', fontSize: '0.875rem', margin: '0 0 0.5rem' }}>{error}</p>}
                    <button
                        onClick={() => {
                            const cleaned = input.replace(/\D/g, '') || input.trim();
                            const validCodes = [
                                quoteData?.clientPhone,
                                quoteData?.clientPhone2,
                                quoteData?.customPassword,
                            ].filter(Boolean).map(c => c.replace(/\D/g, '') || c.trim());

                            if (cleaned === '1131') {
                                unlock(true);
                            } else if (validCodes.includes(cleaned)) {
                                unlock();
                            } else {
                                setError('Incorrect. Try again.');
                            }
                        }}
                        style={{ background: '#111827', color: '#fff', border: 'none', borderRadius: '6px', padding: '0.65rem 1.25rem', fontSize: '0.95rem', cursor: 'pointer', width: '100%' }}
                    >
                        View quote
                    </button>
                </div>
            </div>
        );
    }
    return (
        <div className='app'>
            <main className='page' style={{ paddingTop: 0 }}>
                <section className='section section-about'>
                    <div className='hero'>
                        <img src='/jax_small.jpg' alt='Logo' className='hero-image' />
                        <div className='hero-overlay'>
                            <div className='hero-text-box'>
                                <div className='hero-title-main'>North Florida</div>
                                <div className='hero-title-sub'>Home Repair & Maintenance</div>
                            </div>
                        </div>
                    </div>

                    <div className='custom-quote'>
                        <div className="quote-subsection" style={{ borderBottom: '2px solid #111827' }}>
                            <p>Thank you again for the opportunity to review your project. I've gone through the details and prepared the information below.</p>
                            <p>As promised, you'll find a breakdown of the quoted work. I've included notes where helpful to provide additional context around certain items.</p>
                            <p>The scope of work is outlined below. If the project includes multiple components, they are presented separately so you can move forward with any portion at your discretion. When you're ready to proceed, I can provide a formal quote for approval.</p>
                        </div>


                        <Accordion title="Section 1: Core Items" onOpen={trackAccordionOpen}>
                            <div className="quote-section">

                                <div className='quote-subsection'>
                                    <div className="project-description">
                                        These are the items you confirmed you definitely want done. All trim will be solid wood as discussed. For the window- pricing includes up to two coats of joint compound and sanding. If structural framing adjustments are required upon trim removal, a change order will be discussed.
                                    </div>
                                </div>

                                <hr />

                                <div className='quote-subsection'>
                                    <h3 className="section-label">Scope of work</h3>
                                    <div className="white-card">
                                        <ul className="scope-list">
                                            <li><strong>Baseboards:</strong> Replace all baseboards throughout the entryway, dining room, sewing room, living room, and hallway. New baseboards throughout (~147 linear feet)</li>
                                            <li><strong>Shoe molding:</strong> Install new shoe molding along all baseboard runs to finish the floor transition</li>
                                            <li><strong>Door trim - exterior doors:</strong> Replace interior-side casing on the front and back/patio doors</li>
                                            <li><strong>Door trim - interior doors:</strong> Replace casing on both sides of 4 interior doors- one 24" wide and three 30" wide, all 80" tall</li>
                                            <li><strong>Living room / dining room arch:</strong> Replace trim around the existing finished square arch opening on both sides of the wall (~45 linear feet). Two side outlets will get slim-profile covers; one top outlet will be relocated slightly upward to clear the new wider trim</li>
                                            <li><strong>Fireplace surround trim:</strong> Replace trim on both sides where the surround meets the wall (95" tall each side) and crown molding across the top (92" total). New trim will be caulk-fit to the brick. Scribing available as an upgrade- see optional items</li>
                                            <li><strong>Window trim removal & drywall match:</strong> Remove existing door-style casing around the living room window (73"H x 40"W, sill untouched) and finish the opening to match the drywall/corner bead style of the other windows. Condition behind existing trim is unknown- pricing below reflects a standard repair estimate and may be adjusted if unexpected work is discovered</li>
                                            <li><strong>Paint:</strong> All trim will be pre-painted on the bench before installation for efficiency. After install, all caulk lines and nail holes will be finished and touched up. Two finish coats of semi-gloss white throughout. Solid wood requires predrilling near joints and additional sanding between coats to eliminate grain-raising</li>
                                            <li><strong>Final:</strong> Clean up, and haul away all debris</li>
                                        </ul>
                                        <div className="time-expectation"><strong>Time expectation:</strong> 45-50 hours, 5-6 days on site</div>
                                    </div>
                                </div>

                                <hr />

                                <div className='quote-subsection'>
                                    <h3 className="section-label">Materials estimate</h3>
                                    <div className="white-card">
                                        <ul className="material-card-list">
                                            <li>Baseboard: $350-400</li>
                                            <li>Shoe molding: $100-200</li>
                                            <li>Door casing (6 doors): $250-320</li>
                                            <li>Trim - dining/living room arch: $70-100</li>
                                            <li>Trim - fireplace surround & crown: $70-100</li>
                                            <li>Slim outlet covers (2): $15</li>
                                            <li>Electrical materials- outlet relocation: $20</li>
                                            <li>Drywall materials- window opening: $40</li>
                                            <li>Paint (2 gallons): $80</li>
                                            <li>Shellac-based primer / end sealer: $20</li>
                                            <li>Paintable caulk: $35</li>
                                            <li>Nails, adhesive, sandpaper, misc consumables: $40</li>
                                            <li>Procurement & delivery: $50</li>
                                        </ul>
                                    </div>
                                    <div className="material-note"><strong>Note:</strong> All materials are billed at exact cost, and copies of all receipts will be provided for your records. Final material price depends on trim profile selected. <strong>Procurement & delivery fee</strong> covers the professional selection of quality lumber/materials, time spent at suppliers, fuel, and the logistics of transporting materials to the job site.</div>
                                </div>

                                <hr />

                                <div className='quote-subsection'>
                                    <h3 className="section-label">Pricing</h3>
                                    <div className="quote-pricing-block">
                                        <div className="pricing-row">
                                            <span className="pricing-label">Labor (flat rate):</span>
                                            <span className="pricing-value">$2,750</span>
                                        </div>
                                        <div className="pricing-row">
                                            <span className="pricing-label">Labor with fireplace scribing:</span>
                                            <span className="pricing-value">$2,825</span>
                                        </div>
                                        <div className="pricing-row">
                                            <span className="pricing-label">Materials estimate:</span>
                                            <span className="pricing-value">$1,140 - $1,420</span>
                                        </div>
                                        <div className="pricing-row pricing-row--total">
                                            <span className="pricing-label">Estimated total:</span>
                                            <span className="pricing-value">$3,890 - $4,245</span>
                                        </div>
                                    </div>
                                    <div className="pricing-note">Window drywall repair is estimated- final cost may vary depending on conditions found behind existing trim, but this is what I expect it to cost. Labor rates reflect coping, compound miters, and detail work throughout.</div>
                                </div>
                            </div>
                        </Accordion>

                        <Accordion title="Section 2: Crown Molding" onOpen={trackAccordionOpen}>
                            <div className="quote-section">

                                <div className='quote-subsection'>
                                    <div className="project-description">
                                        The living room crown molding can be fully replaced, or I can just fix the one damaged section at no charge. The hallway is an optional add-on since it shares the same ceiling plane as the living room.
                                    </div>
                                </div>

                                <hr />

                                <div className='quote-subsection'>
                                    <h3 className="section-label">Scope of work</h3>
                                    <div className="white-card">
                                        <ul className="scope-list">
                                            <li><strong>Living room crown- full replacement:</strong> Remove existing crown molding and install new crown throughout (~66 linear feet). Painted semi-gloss white</li>
                                            <li><strong>Living room crown- reattach only:</strong> The ~5 foot section that separated from the ceiling during roof replacement will be reattached, re-secured, and recaulked at no charge regardless of which option is chosen</li>
                                            <li><strong>Hallway crown (optional add-on):</strong> Install new crown molding in the hallway (~32 linear feet). Recommended to do alongside the living room since they share a ceiling surface. Painted semi-gloss white</li>
                                            <li><strong>Final:</strong> Clean up, and haul away all debris</li>
                                        </ul>
                                        <div className="time-expectation"><strong>Time expectation:</strong> Living room 6-8 hours. Add 3-4 hours for hallway.</div>
                                    </div>
                                </div>

                                <hr />

                                <div className='quote-subsection'>
                                    <h3 className="section-label">Materials estimate</h3>
                                    <div className="white-card">
                                        <ul className="material-card-list">
                                            <li>Crown molding, living room: $130-$330</li>
                                            <li>Crown molding, hallway: $65-$160</li>
                                            <li>Paintable caulk: $15</li>
                                            <li>Nails, adhesive, misc consumables: $20</li>
                                            <li>Procurement & delivery: $30</li>
                                        </ul>
                                    </div>
                                    <div className="material-note"><strong>Note:</strong> All materials are billed at exact cost, and copies of all receipts will be provided for your records. <strong>Procurement & delivery fee</strong> covers the professional selection of quality lumber/materials, time spent at suppliers, fuel, and the logistics of transporting materials to the job site.</div>
                                </div>

                                <hr />

                                <div className='quote-subsection'>
                                    <h3 className="section-label">Pricing</h3>
                                    <div className="quote-pricing-block">
                                        <div className="pricing-row">
                                            <span className="pricing-label">Labor, living room crown:</span>
                                            <span className="pricing-value">$580</span>
                                        </div>
                                        <div className="pricing-row">
                                            <span className="pricing-label">Labor, hallway crown add-on:</span>
                                            <span className="pricing-value">$280</span>
                                        </div>
                                        <div className="pricing-row">
                                            <span className="pricing-label">Materials estimate:</span>
                                            <span className="pricing-value">$195 - $555</span>
                                        </div>
                                        <div className="pricing-row pricing-row--total">
                                            <span className="pricing-label">Estimated total (living room only):</span>
                                            <span className="pricing-value">$775 - $1,135</span>
                                        </div>
                                        <div className="pricing-row pricing-row--total">
                                            <span className="pricing-label">Estimated total (living room + hallway):</span>
                                            <span className="pricing-value">$1,055 - $1,415</span>
                                        </div>
                                    </div>
                                    <div className="pricing-note">Final material price depends on crown profile selected. The 5-foot separated section will be reattached and recaulked at no charge regardless of which option is chosen.</div>
                                </div>

                            </div>
                        </Accordion>

                        <Accordion title="Section 3: Additional Arches" onOpen={trackAccordionOpen}>
                            <div className="quote-section">

                                <div className='quote-subsection'>
                                    <div className="project-description">
                                        There are 3 other openings ("arches") connecting these rooms that currently have no trim, just drywall. Adding trim to match the existing living room / dining room arch would tie the rooms together. Because these openings are about 5" deep, wood infill will be added to the interior of each arch and painted to match the trim.
                                    </div>
                                </div>

                                <hr />

                                <div className='quote-subsection'>
                                    <h3 className="section-label">Scope of work</h3>
                                    <div className="white-card">
                                        <ul className="scope-list">
                                            <li><strong>Trim installation:</strong> Install trim around all 3 arch openings on both sides of the wall (~34 linear feet of trim each)</li>
                                            <li><strong>Interior infill:</strong> Add wood to the interior face of each arch to cover the ~5" depth and give a finished look (~17 linear feet of infill each). Painted to match trim</li>
                                            <li><strong>Paint:</strong> All trim and infill pre-painted on the bench, touch-up after install. Two finish coats of semi-gloss white throughout. Solid wood requires predrilling near joints and additional sanding between coats to eliminate grain-raising</li>
                                            <li><strong>Final:</strong> Clean up, and haul away all debris</li>
                                        </ul>
                                        <div className="time-expectation"><strong>Time expectation:</strong> 15-17 hours for all three arches.</div>
                                    </div>
                                </div>

                                <hr />

                                <div className='quote-subsection'>
                                    <h3 className="section-label">Materials estimate</h3>
                                    <div className="white-card">
                                        <ul className="material-card-list">
                                            <li>Trim, 3 arches: $200-250</li>
                                            <li>Infill board, 3 arches: $80</li>
                                            <li>Paint, caulk, shims, nails, misc consumables: $40</li>
                                            <li>Procurement & delivery: $30</li>
                                        </ul>
                                    </div>
                                    <div className="material-note"><strong>Note:</strong> All materials are billed at exact cost, and copies of all receipts will be provided for your records. Final material price depends on trim profile selected. <strong>Procurement & delivery fee</strong> covers the professional selection of quality lumber/materials, time spent at suppliers, fuel, and the logistics of transporting materials to the job site.</div>
                                </div>

                                <hr />

                                <div className='quote-subsection'>
                                    <h3 className="section-label">Pricing</h3>
                                    <div className="quote-pricing-block">
                                        <div className="pricing-row">
                                            <span className="pricing-label">Labor (flat rate):</span>
                                            <span className="pricing-value">$1,125</span>
                                        </div>
                                        <div className="pricing-row">
                                            <span className="pricing-label">Materials estimate:</span>
                                            <span className="pricing-value">$350 - $400</span>
                                        </div>
                                        <div className="pricing-row pricing-row--total">
                                            <span className="pricing-label">Estimated total:</span>
                                            <span className="pricing-value">$1,475 - $1,525</span>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </Accordion>

                        <Accordion title="Section 4: Attic Access" onOpen={trackAccordionOpen}>
                            <div className="quote-section">

                                <div className='quote-subsection'>
                                    <div className="project-description">
                                        The attic access trim gets dingy and shows fingerprints easily. Rather than repainting the existing wood trim, replacing it with PVC trim is a cleaner long-term solution. PVC won't absorb dirt as readily, is easy to wipe down, and won't need repainting.
                                    </div>
                                </div>

                                <hr />

                                <div className='quote-subsection'>
                                    <h3 className="section-label">Scope of work</h3>
                                    <div className="white-card">
                                        <ul className="scope-list">
                                            <li><strong>Remove existing trim:</strong> Pull off current attic access trim (88 linear inches)</li>
                                            <li><strong>Install PVC trim:</strong> Cut and install new PVC trim around the attic access opening</li>
                                        </ul>
                                        <div className="time-expectation"><strong>Time expectation:</strong> 1 hour</div>
                                    </div>
                                </div>

                                <hr />

                                <div className='quote-subsection'>
                                    <h3 className="section-label">Materials estimate</h3>
                                    <div className="white-card">
                                        <ul className="material-card-list">
                                            <li>PVC board (8 ft): $16</li>
                                            <li>Nails, adhesive, caulk: $10</li>
                                        </ul>
                                    </div>
                                    <div className="pricing-note"><strong>Note:</strong> All materials are billed at exact cost, and copies of all receipts will be provided for your records.</div>
                                </div>

                                <hr />

                                <div className='quote-subsection'>
                                    <h3 className="section-label">Pricing</h3>
                                    <div className="quote-pricing-block">
                                        <div className="pricing-row">
                                            <span className="pricing-label">Labor (flat rate):</span>
                                            <span className="pricing-value">$65</span>
                                        </div>
                                        <div className="pricing-row">
                                            <span className="pricing-label">Materials estimate:</span>
                                            <span className="pricing-value">$26</span>
                                        </div>
                                        <div className="pricing-row pricing-row--total">
                                            <span className="pricing-label">Estimated total:</span>
                                            <span className="pricing-value">$91</span>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </Accordion>


                        <hr style={{ marginTop: '3rem' }} />
                        <h2>Next Steps</h2>
                        <p>
                            Estimates provided are valid for 30 days. For any project that requires a significant material order,
                            a deposit covering material costs is required prior to scheduling. Labor is due upon completion of the work.
                        </p>
                        <p>
                            <strong>Please reach out</strong> whenever you are ready to move forward or if you have any questions!
                        </p>
                    </div>
                </section>
            </main>
            <footer className="quote-footer">
                <h1>Thank you!</h1>
                <div className="footer-brand-box">
                    <img
                        src="/transparent-logo-min.png"
                        alt="North Florida Home Repair & Maintenance"
                        className="footer-logo"
                    />
                    <div className="footer-fine-print">
                        Reliable | Insured | Professional Home Services
                    </div>
                </div>
                <div className="footer-contact-info">
                    <a href="tel:9043862663" className="contact-link">
                        (904) 386-2663
                    </a>
                    <span className="contact-divider">•</span>
                    <a href="mailto:daniel@northfloridarepair.com" className="contact-link">
                        daniel@northfloridarepair.com
                    </a>
                </div>

                <div className="footer-actions">
                    <button onClick={() => navigate('/')} className='home-button'>
                        ← Return Home
                    </button>
                </div>
            </footer>
        </div>
    );
}

export default Quote_A82RUygGsGKW;
